export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon-telegram.d335b1bb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};